"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _useAppInstallability2 = require("ecosystem-marketplace-core/utils/hooks/useAppInstallability");

var AppUninstallableReasons = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/installability/AppUninstallableReasons"));

var _ConnectActions = require("../../../actions/ConnectActions");

var _useShortlinkParams = _interopRequireDefault(require("../../../utils/hooks/useShortlinkParams"));

var _offerings = require("../../../utils/offerings");

var _urls = require("../../../utils/urls");

var AsyncRequestPermissionsModal = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'request-permissions-modal' */
    './RequestPermissionsModal');
  }
});
var AsyncIntegrationsConnectButton = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'integrations-connect-button' */
    'ui-addon-integrations-directory-panel/UIIntegrationsConnectButton');
  }
});
var AsyncIntegrationsConnectModal = (0, _Loadable.default)({
  loader: function loader() {
    return import(
    /* webpackChunkName: 'integrations-connect-modal' */
    'ui-addon-integrations-directory-panel/UIIntegrationsConnectModal');
  }
});
var keyPath = 'appMarketplace.detail.header.connectAppButton';
var connectButtonKeyPath = keyPath + ".text";

var ConnectButton = function ConnectButton(_ref) {
  var appId = _ref.appId,
      appName = _ref.appName,
      appUrl = _ref.appUrl,
      connectionType = _ref.connectionType,
      installability = _ref.installability,
      isCustomer = _ref.isCustomer,
      listingId = _ref.listingId,
      onConnectButtonClick = _ref.onConnectButtonClick,
      onConnectFailed = _ref.onConnectFailed,
      onTrackInteraction = _ref.onTrackInteraction,
      sticky = _ref.sticky;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  var shortlinkParams = (0, _useShortlinkParams.default)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      openIframeModal = _useState2[0],
      setOpenIframeModal = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      openPermissionsModal = _useState4[0],
      setOpenPermissionsModal = _useState4[1];

  var standardConnection = (0, _offerings.getIsStandardConnection)(connectionType);
  var homemadeExternalConnection = (0, _offerings.getIsHomemadeExternalConnection)(connectionType);
  var homemadeModalConnection = (0, _offerings.getIsHomemadeModalConnection)(connectionType);

  var _useAppInstallability = (0, _useAppInstallability2.useAppInstallability)({
    installability: installability
  }),
      isAppInstallable = _useAppInstallability.isAppInstallable,
      appUninstallableReason = _useAppInstallability.appUninstallableReason,
      appInstallabilityExtras = _useAppInstallability.appInstallabilityExtras; // Public connect button that rediredcts to portal picker


  if (!isCustomer) {
    return _react.default.createElement(_UIButton.default, {
      size: sticky ? 'small' : 'default',
      use: "primary",
      href: (0, _urls.getAppShortlink)(pathname, shortlinkParams),
      onClick: onConnectButtonClick
    }, _react.default.createElement(_FormattedMessage.default, {
      message: keyPath + ".publicText"
    }));
  }

  if (appUninstallableReason === AppUninstallableReasons.MISSING_USER_PERMISSIONS) {
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIButton.default, {
      size: sticky ? 'small' : 'default',
      use: "primary",
      onClick: function onClick() {
        return setOpenPermissionsModal(true);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: keyPath + ".requestToConnect"
    })), openPermissionsModal && _react.default.createElement(AsyncRequestPermissionsModal, {
      listingId: listingId,
      missingHubUserRoles: appInstallabilityExtras,
      onClose: function onClose() {
        return setOpenPermissionsModal(false);
      }
    }));
  }

  var tooltipKey;
  var tooltipOptions = {};

  switch (appUninstallableReason) {
    case AppUninstallableReasons.ALREADY_INSTALLED:
      tooltipKey = 'installed';
      break;

    case AppUninstallableReasons.MISSING_HUB_SCOPES:
      // TODO placeholder until PQL modal
      tooltipKey = 'missingHubScopes';
      break;

    case AppUninstallableReasons.INCOMPATIBLE_INSTALLS:
      tooltipKey = 'incompatibleInstalls';
      tooltipOptions = {
        count: appInstallabilityExtras.size,
        installs: _I18n.default.formatList(appInstallabilityExtras.toArray())
      };
      break;

    default:
      {
        if (!isAppInstallable) {
          tooltipKey = 'missingHubUserInstallable';
        }

        break;
      }
  } // Simple button and disabled button for integrations


  if (tooltipKey || standardConnection || homemadeExternalConnection) {
    var tooltip = tooltipKey ? _react.default.createElement(_FormattedMessage.default, {
      message: keyPath + ".tooltip." + tooltipKey,
      options: tooltipOptions
    }) : null;
    return _react.default.createElement(_UITooltip.default, {
      title: tooltip,
      disabled: !tooltip
    }, _react.default.createElement(_UIButton.default, {
      size: sticky ? 'small' : 'default',
      use: "primary",
      disabled: !!tooltip,
      external: standardConnection && !tooltip,
      href: isAppInstallable ? (0, _urls.getFormattedUrl)(appUrl) : null,
      onClick: onConnectButtonClick
    }, _react.default.createElement(_FormattedMessage.default, {
      message: connectButtonKeyPath
    })));
  } // Iframe modal button


  if (homemadeModalConnection) {
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIButton.default, {
      size: sticky ? 'small' : 'default',
      use: "primary",
      onClick: function onClick() {
        setOpenIframeModal(true);
        onTrackInteraction('click connect button', 'header', appName);
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: connectButtonKeyPath
    })), openIframeModal && _react.default.createElement(_UIModal.default, {
      width: 600,
      use: "success"
    }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: function onClick() {
        return setOpenIframeModal(false);
      }
    }), _react.default.createElement(_H.default, {
      "aria-level": 2
    }, _react.default.createElement(_FormattedMessage.default, {
      message: keyPath + ".modalTitle"
    }))), _react.default.createElement(_UIDialogBody.default, {
      className: "p-bottom-4"
    }, _react.default.createElement(AsyncIntegrationsConnectModal, {
      portalId: _PortalIdParser.default.get(),
      appId: appId,
      sourceAppId: "app-marketplace",
      text: _I18n.default.text(connectButtonKeyPath),
      onConnectionComplete: function onConnectionComplete() {
        window.location.href = (0, _urls.getConnectedAppsUrl)();
      },
      onIntegrationNotFound: function onIntegrationNotFound() {
        console.log('not found');
      }
    }))));
  } // Iframe button


  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    style: {
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    className: "m-left-3"
  }, _react.default.createElement(AsyncIntegrationsConnectButton, {
    portalId: _PortalIdParser.default.get(),
    appId: appId,
    sourceAppId: "app-marketplace",
    text: _I18n.default.text(connectButtonKeyPath),
    onClick: function onClick() {
      return onTrackInteraction('click connect button', 'header', appName);
    },
    onConnectionComplete: function onConnectionComplete() {
      window.location.href = (0, _urls.getConnectedAppsUrl)();
    },
    onConnectionFailed: function onConnectionFailed(err) {
      return onConnectFailed(err.meta.type, appName);
    }
  })));
};

ConnectButton.propTypes = {
  appId: _propTypes.default.number,
  appName: _propTypes.default.string.isRequired,
  appUrl: _propTypes.default.string,
  connectionType: CustomPropTypes.connectionType.isRequired,
  installability: CustomPropTypes.installability.isRequired,
  isCustomer: _propTypes.default.bool,
  listingId: _propTypes.default.number.isRequired,
  onConnectButtonClick: _propTypes.default.func.isRequired,
  onConnectFailed: _propTypes.default.func.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired,
  sticky: _propTypes.default.bool
};
var mapDispatchToProps = {
  onConnectFailed: _ConnectActions.handleConnectError
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ConnectButton);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/connect/ConnectButton.js
// module id = 791
// module chunks = 209 210 211 212